
import { Camera, Counter, CounterRecord } from '@/api';
import { viewModelRepository } from '@/api/common';
import { mapObjectToSelectItem } from '@/common/utilsFilterSchema';
import FilterSection from '@/components/common/filter/FilterSection.vue';
import InfiniteScroll from '@/components/common/InfiniteScroll.vue';
import { getCounterRecordFilters } from '@/pages/counters/counterFiltersBuilder';
import { dataAssetsModule } from '@/store/application/data.assets.module';
import { dataModule } from '@/store/data';
import NTable from '@/uikit/table/NTable.vue';
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import columns from './schemes/counter-records-columns';
import { configModule } from '@/store/config';

function gatherRecordBboxes(record: CounterRecord) {
  return [...(record.faces_bbox ?? []), ...(record.cars_bbox ?? []), ...(record.silhouettes_bbox ?? [])];
}

@Options({
  name: 'CounterRecords',
  components: { FilterSection, InfiniteScroll, NTable }
})
export default class CounterRecords extends Vue {
  @Prop({ type: Object, required: true })
  readonly item!: Counter;

  readonly module = viewModelRepository.getCounterRecordsListViewModel();

  cameraItems: any = [];
  objects = {
    face: 'faces_count',
    body: 'silhouettes_count',
    car: 'cars_count'
  };

  get columns() {
    let result = [...columns];
    const disabledObjects = Object.keys(this.objects as any).filter(item => !dataAssetsModule.availableObjects.includes(item)).map(item => (this.objects as any)[item]);
    if (!configModule.config.counters?.show_proximity) result = result.filter(item => item.content.path !== 'distance');
    return result.filter(item => !disabledObjects.includes(item.content.path as string));
  }

  @Watch('module.filter.current', { deep: true })
  changeFilterHandler(v: any, p: any) {
    this.module.get();
  }

  @Watch('item.id')
  async load() {
    this.module.filter.force.counter = [this.item.id];
    this.module.get();
    this.cameraItems = mapObjectToSelectItem(await this.getAvailableCameras());
  }

  get smallFiltersLayout() {
    return getCounterRecordFilters({ small: true }, this.cameraItems);
  }

  get largeFiltersLayout() {
    return getCounterRecordFilters({}, this.cameraItems);
  }

  async getAvailableCameras(): Promise<Camera[]> {
    let result: Camera[] = [];
    try {
      result = await dataModule.camerasModule.getByIds(this.item!.cameras);
    } catch (e: any) {
      console.warn('[filter:getAvailableCameras] ', e);
    }
    return result;
  }

  mounted() {
    this.load();
  }

  handleTableAction(record: CounterRecord) {
    const item = { fullframe: record.fullframe, bboxes: gatherRecordBboxes(record), roiPoints: this.item.roi?.[String(record.camera)] ?? undefined };
    this.$photoViewer.show(item);
  }
}
